export default () => ({
  attachments: [],
});
